import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('article', {
    staticClass: "crm-timeline-item"
  }, [_c('span', {
    staticClass: "crm-timeline-dot",
    class: _vm.dotClass
  }), _c('div', {
    staticClass: "crm-timeline-content"
  }, [_c('div', {
    staticClass: "crm-timeline-title-row"
  }, [_c('strong', [_vm._v(_vm._s(_vm.title))]), _c('small', [_vm._v(_vm._s(_vm.dateText))])]), _vm.description ? _c('p', {
    staticClass: "crm-timeline-description"
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e(), _c('div', {
    staticClass: "crm-timeline-meta"
  }, [_c('span', [_vm._v(_vm._s(_vm.user || "CRM"))]), _vm.type ? _c('span', {
    staticClass: "crm-timeline-type"
  }, [_vm._v(_vm._s(_vm.type))]) : _vm._e()]), _vm.$slots.actions ? _c('div', {
    staticClass: "crm-timeline-actions"
  }, [_vm._t("actions")], 2) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };